import { AbstractControl, ValidationErrors } from '@angular/forms';
import { BetonOrderDeliveryAddress } from '@beton/const';

/**
 * Данный валидатор проверяет наличие координат и номера дома
 */
export function ValidateDeliveryAddress(control: AbstractControl): ValidationErrors {
  const betonOrderDeliveryAddress = control.value as BetonOrderDeliveryAddress;

  if (!betonOrderDeliveryAddress) {
    return null;
  }

  if (!betonOrderDeliveryAddress.point.latitude || !betonOrderDeliveryAddress.streetNumber) {
    return { incompleteAddress: true } as ValidationErrors;
  }

  return null;
}
